import React, { useCallback, useEffect, useState } from "react";

import {
  IconCheck,
  IconCircleXFilled,
  IconDiscountCheckFilled,
  IconSwitch,
  IconX,
} from "@tabler/icons-react";
import { Timeline, Text, Button, Stepper, ScrollArea } from "@mantine/core";
import { ProcessApprove } from "../../model/ProcessApprove";
import { Icon12Hours } from "@tabler/icons-react";
import { SkeletonBase } from "../../_base/component/Core/SkeletonBase";

const PopupProcess = ({ data }: { data?: ProcessApprove[] }) => {
  const [bbb, setBBB] = useState<boolean>(false);

  //   useEffect(() => {
  //     console.log(id);
  //   }, [id]);

  const l1 = () => {
    return (
      <div className="customer-process-ins">
        <div className="wrap-ui-process ng-star-inserted">
          <div className="ui-steps ng-star-inserted">
            <div
              className="circle"
              style={{ border: "2px solid rgb(55, 167, 0);" }}
            >
              <IconDiscountCheckFilled size={"35px"} />
            </div>
            <div
              className="ui-triangle"
              style={{ borderBottom: "10px solid rgb(55, 167, 0)" }}
            ></div>
            <div className="step">
              <div
                className="step-header"
                style={{ backgroundColor: "rgb(55, 167, 0)" }}
              >
                Gửi phê duyệt (Bước 1)
              </div>
              <div className="step-content ng-star-inserted">
                <div
                  className="title-process"
                  style={{
                    backgroundColor: "rgba(55, 167, 0, 0.1)",
                  }}
                ></div>
                <div
                  _ngcontent-qtx-c216=""
                  className="user-name ng-star-inserted"
                >
                  Nguyễn Văn Mạnh
                </div>
                <div></div>
                <div className="process-date ng-star-inserted">
                  22/02/2024 15:36
                </div>
              </div>
            </div>
          </div>
          <div className="ui-steps ng-star-inserted">
            <div
              className="circle"
              style={{ border: "2px solid rgb(55, 167, 0);" }}
            >
              <IconDiscountCheckFilled size={"35px"} />
            </div>
            <div
              className="ui-triangle"
              style={{ borderBottom: "10px solid rgb(55, 167, 0)" }}
            ></div>
            <div className="step">
              <div
                className="step-header"
                style={{ backgroundColor: "rgb(55, 167, 0)" }}
              >
                Duyệt (Bước 2)
              </div>
              <div className="step-content ng-star-inserted">
                <div className="user-name ng-star-inserted">
                  Nguyễn Văn Mạnh
                </div>
                <div></div>
                <div className="task-other-info ng-star-inserted">
                  {" "}
                  Loại duyệt: Duyệt
                </div>
                <div className="process-date ng-star-inserted">
                  22/02/2024 15:37
                </div>
              </div>
            </div>
          </div>
          <div className="ui-steps ng-star-inserted">
            <div className="circle" style={{ color: "#673AB7" }}>
              <IconCircleXFilled size={"35px"} />
            </div>
            <div
              className="ui-triangle"
              style={{ borderBottom: "10px solid #673AB7" }}
            ></div>
            <div className="step" style={{ marginLeft: "70px;" }}>
              <div
                className="step-header"
                style={{
                  backgroundColor: "#673AB7",
                }}
              >
                Ký (Bước 3)
              </div>
              <div className="step-content ng-star-inserted">
                <div className="user-name ng-star-inserted">Nguyễn Khả Hơp</div>
                <div></div>
                <div className="task-other-info ng-star-inserted">
                  Không eKYC
                </div>
                <div className="task-other-info ng-star-inserted">
                  {" "}
                  Loại duyệt: Ký ảnh &amp; duyệt
                </div>
              </div>
            </div>
          </div>
          <div className="ui-steps last-steps">
            <div className="end-steps"></div>
          </div>
        </div>
      </div>
    );
  };

  const l2 = () => {
    return (
      <>
        {data && (
          <Timeline
            ml={"20px"}
            mt={"20px"}
            active={data.length}
            bulletSize={24}
            lineWidth={3}
          >
            {data.map((processApprove, index) => (
              <Timeline.Item
                bullet={getIcon(processApprove)}
                title={processApprove.step}
                color={getColor(processApprove)}
              >
                <Text size="sm" style={{ fontWeight: "bold" }}>
                  {processApprove.by}
                </Text>
                {processApprove.date && (
                  <Text size="xs" mt={4}>
                    {processApprove.date}
                  </Text>
                )}
              </Timeline.Item>
            ))}

            {/* <Timeline.Item
              bullet={<IconCheck size={12} />}
              title="Gửi phê duyệt (Bước 1)"
            >
              <Text size="sm" style={{ fontWeight: "bold" }}>
                Nguyễn Văn Mạnh
              </Text>
              <Text size="xs" mt={4}>
                22/02/2024 15:36
              </Text>
            </Timeline.Item>

            <Timeline.Item bullet={<IconX size={12} />} title="Duyệt (Bước 2)">
              <Text size="sm" style={{ fontWeight: "bold" }}>
                Nguyễn Văn Mạnh
              </Text>
              <Text c="dimmed" component="span" inherit>
                Loại duyệt: Duyệt
              </Text>
              <Text size="xs" mt={4}>
                22/02/2024 15:36
              </Text>
            </Timeline.Item>

            <Timeline.Item
              color="red"
              title="Ký (Bước 3)"
              bullet={<IconX size={12} />}
              lineVariant="dashed"
            >
              <Text size="sm" style={{ fontWeight: "bold" }}>
                Nguyễn Khả Hơp
              </Text>
              <Text component="span" inherit>
                Không eKYC
              </Text>
              <Text>Loại duyệt: Ký ảnh & duyệt</Text>
              <Text size="xs" mt={4}>
                22/02/2024 15:36
              </Text>
            </Timeline.Item> */}

            {/* <Timeline.Item
              title="Hoàn thành"
              //  bullet={<IconMessageDots size={12} />}
            >
              <Text c="dimmed" size="sm">
                Chưa hoàn thành
              </Text>
              <Text size="xs" mt={4}></Text>
            </Timeline.Item> */}
          </Timeline>
        )}
      </>
    );
  };

  const getIcon = (model: ProcessApprove) => {
    if (model.date && model.status === "NEXT") return <IconCheck size={12} />;
    if (model.date && model.status === "REJECT") return <IconX size={12} />;
    if (!model.date && model.status === "NEXT")
      return <Icon12Hours size={12} />;
  };
  const getColor = (model: ProcessApprove) => {
    if (model.date && model.status === "NEXT") return "";
    if (model.date && model.status === "REJECT") return "red";
    if (!model.date && model.status === "NEXT") return "gray";
  };

  return (
    <>
      {/* <Button
        leftSection={<IconSwitch size={14} />}
        color="blue"
        mt={"xs"}
        style={{ width: "180px" }}
        variant="outline"
        onClick={() => {
          setBBB(!bbb);
          console.log(bbb);
        }}
      >
        Đổi
      </Button> */}
      {data ? <>{l2()}</> : <SkeletonBase />}
    </>
  );
};

export default PopupProcess;
